import { exchangeMonthAndDayInDate } from '../pages/Recruitment/InterviewStatusReport/InterviewStatusReportHelpers'

// function will take dd/mm/yyyy format
export const openToDateHandler = (enteredDate: string): Date => {
  const finalDate = enteredDate ? exchangeMonthAndDayInDate(enteredDate) : '' // converting to mm/dd/yyyy format
  return !isNaN(Date?.parse(finalDate)) ? new Date(finalDate) : new Date()
}
